import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import vuetify from './plugins/vuetify';
import EnlargeableImage from '@diracleo/vue-enlargeable-image';

Vue.config.productionTip = false
Vue.use(EnlargeableImage)

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')

